import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChainsService } from 'src/app/services/chains.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-chains-list',
  templateUrl: './chains-list.component.html',
  styleUrls: ['./chains-list.component.scss']
})
export class ChainsListComponent implements OnInit {
  chains: any[] = [];
  filteredChains: any[] = [];
  word: string = '';
  page: number = 1;
  count: number = 10;
  total: number = 0;
  role: string = localStorage.getItem('role') || '';

  constructor(
    private chainsService: ChainsService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadChains();
  }

  loadChains(): void {
    this.spinner.show();
    this.chainsService.getChains().subscribe({
      next: (res: any) => {
        this.chains = res.chains || res.response?.data?.chains || [];
        this.total = res.total || this.chains.length;
        this.filteredChains = [...this.chains];
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
        Swal.fire('Error', err.error?.response?.message || 'Failed to load chains', 'error');
      }
    });
  }

  onFilterKeySearch(): void {
    const term = this.word.toLowerCase();
    this.filteredChains = this.chains.filter(c =>
      c.chainName?.toLowerCase().includes(term) ||
      c.description?.toLowerCase().includes(term)
    );
    this.total = this.filteredChains.length;
    this.page = 1;
  }

  addChain(): void {
    this.router.navigate(['/chainforms']);
  }

  editChain(id: string): void {
    this.router.navigate(['/editchain', id]);
  }

  viewReports(id: string): void {
    this.router.navigate(['/chain-reports', id]);
  }

  viewOverview(id: string): void {
    this.router.navigate(['/chain', id, 'overview']);
  }

  deleteChain(id: string, chainName: string): void {
    Swal.fire({
      title: `Delete "${chainName}"?`,
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it'
    }).then(result => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.chainsService.deleteChain(id).subscribe({
          next: () => {
            this.spinner.hide();
            Swal.fire('Deleted!', 'Chain has been deleted.', 'success');
            this.loadChains();
          },
          error: (err: any) => {
            this.spinner.hide();
            Swal.fire('Error', err.error?.response?.message || 'Failed to delete chain', 'error');
          }
        });
      }
    });
  }

  pageChanged(event: number): void {
    this.page = event;
  }

  goToBranding(chainId: string): void {
    this.router.navigate(['/chain', chainId, 'branding']);
  }

  goToCatalog(chainId: string): void {
    this.router.navigate(['/chain', chainId, 'catalog']);
  }

  goToLoyalty(chainId: string): void {
    this.router.navigate(['/chain', chainId, 'loyalty']);
  }

  getStatusText(status: any): string {
    return status === 1 || status === true ? 'Active' : 'Inactive';
  }

  getStatusBadge(status: any): string {
    return status === 1 || status === true ? 'success' : 'warning';
  }
}
